import { RadioGroup } from '@anyui/core';
import { cn } from '@anytag/shared-utils';
import { CheckBox, Radio } from '@anytag/shared-atoms';
import { AnalyticsCompareOverviewLegendType } from './types';

export interface AnalyticsCompareOverviewLegendProps<T extends string> {
  className?: string;
  selectedOptions: T[];
  options: AnalyticsCompareOverviewLegendType<T>[];
  onSelectOption?: (option: AnalyticsCompareOverviewLegendType<T>) => void;
}
export const AnalyticsCompareOverviewLegend = <T extends string>({
  options,
  className,
  onSelectOption,
  selectedOptions
}: AnalyticsCompareOverviewLegendProps<T>) => (
  <RadioGroup
    className={className}
    value={options.find((option) => selectedOptions.includes(option.value) && option.type === 'radio')?.value}
    onChange={(value) =>
      onSelectOption?.(options.find((option) => option.value === value) as AnalyticsCompareOverviewLegendType<T>)
    }
  >
    {options.map((option, index) => {
      const { label, value, type } = option;
      const isCheckBox = type === 'checkbox';
      const isChecked = selectedOptions.includes(value);
      const isLastCheckBox = isCheckBox && options[index + 1]?.type === 'radio';

      return (
        <div
          key={value}
          onClick={() => onSelectOption?.(option)}
          className={cn('flex items-center p-1 [&:not(:last-of-type)]:mr-2', {
            'border-r-border pr-3': isLastCheckBox
          })}
        >
          {isCheckBox ? <CheckBox checked={isChecked} label={label} /> : <Radio value={value} label={label} />}
        </div>
      );
    })}
  </RadioGroup>
);
